module.exports = __webpack_public_path__ + "static/media/locations-import.ae1c0465.csv";


//////////////////
// WEBPACK FOOTER
// ./src/assets/locations-import.csv
// module id = ./src/assets/locations-import.csv
// module chunks = 11